/* @flow */
import React from 'react';
import cx from 'classnames';
import ActivityRecipient from 'entities/ActivityRecipient';
import Activity from 'entities/Activity';
import PaymentViewSideInformation from 'payments/components/PaymentViewSideInformation.jsx';
import RSVPFlow from 'payments/components/RSVPFlow.jsx';
import withWidth from 'lib/withWidth';
import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line

import './styles/PaymentView.scss';

type Props = {
  width: number,
  activity: Activity,
  isUnderage: boolean,
  initialRSVP: ?Attendance,
  initialActivityRecipient: ?ActivityRecipient,
};

class PaymentView extends React.Component {
  props: Props;

  render() {
    const { activity } = this.props;

    if (!activity) {
      return null;
    }

    const isVertical = this.props.width < 900;
    const isVerticalSlim = this.props.width < 500;

    const vertical = { 'PaymentView-vertical': isVertical };
    const horizontal = { 'PaymentView-horizontal': !isVertical };
    const verticalSlim = { 'PaymentView-vertical-slim': isVerticalSlim };

    return (
      <div className={cx('PaymentView', horizontal, vertical, verticalSlim)}>
        <div className="PaymentView-panel PaymentView-panel-rsvp">
          <RSVPFlow
            activity={this.props.activity}
            isUnderage={this.props.isUnderage}
            initialRSVP={this.props.initialRSVP}
            headerAlign={isVerticalSlim ? 'left' : 'center'}
            initialActivityRecipient={this.props.initialActivityRecipient}
          />
        </div>
        <div className="PaymentView-panel PaymentView-panel-info">
          <PaymentViewSideInformation activity={this.props.activity} />
        </div>
      </div>
    );
  }
}

export default withWidth(PaymentView);



// WEBPACK FOOTER //
// ./src/rsvp/components/PaymentView.jsx